import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FaqSection from './components/FaqSection';
import NewsletterSection from './components/NewsletterSection';

const NEWSLETTER_SUBMIT_ADDR = 'https://readdy.ai/api/form/d9u2blt3pcjqs2fcskt0';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '诱人的飞行',
    url: 'https://jidishuzi.cn/',
    description: '探索全球最具吸引力的航空旅行体验，从独家航线到奢华机舱，为你精选飞行方案。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://jidishuzi.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '诱人的飞行',
    url: 'https://jidishuzi.cn/',
    description: '专注于航空旅行体验的中文内容平台',
    sameAs: ['https://weibo.com/', 'https://www.xiaohongshu.com/'],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <FaqSection />
        <NewsletterSection submitAddr={NEWSLETTER_SUBMIT_ADDR} />
      </main>
      <Footer />
    </>
  );
}